import React, { useState, useEffect } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { useParams } from 'react-router-dom';
import { fetchSingleEmployee, updateEmployeeEntry } from '../../Store/PHPSlice/Employee';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { selectItems, selectSingleJobrate } from '../Selectors/Master/ItemSelectors';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchSingleJobRate, updateJobRate } from '../../Store/PHPSlice/JobRate';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';


const JobRateEdit = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        jobId: Id,
        dt: '',
        itemId: '',
        itemNm: "",
        total: '0',
        extra: '0',
        contractor: '0',
        userId: '1'
    });
    const [errors, setErrors] = useState({});

    const [departData, setDepartData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const itemList = useSelector(selectItems);
    const departlist = useSelector(selectDaparement);
    const jobdata = useSelector(selectSingleJobrate);

    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchDepartmentData());
        dispatch(fetchSingleJobRate(Id));
    }, [dispatch]);


    useEffect(() => {
        if (jobdata?.data) {
            const value = jobdata?.data;
            setFormData(prev => ({
                ...prev,
                dt: value.dt,
                extra: value.extra,
                itemId: value.itemId,
                itemNm: value.itemNm,
                total: value.total
            }));
        }
        if (jobdata?.jobInfo?.length > 0) {
            const data = JSON.parse(JSON.stringify(jobdata?.jobInfo));
            setDepartData(data);
        }
    }, [jobdata]);

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph' || name === 'amt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleInputChange2 = (e, index) => {
        const { value } = e.target;

        // Update the specific department's value
        const updatedDepartData = departData.map((dept, idx) =>
            idx === index ? { ...dept, rate: value } : dept
        );

        setDepartData(updatedDepartData);

        // Calculate the total and update formData
        let total = updatedDepartData.reduce(
            (sum, dept) => sum + parseFloat(dept.rate || 0),
            0
        );

        setFormData((prev) => ({ ...prev, total: total.toFixed(2) }));
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };

    function postObj(formData, departData) {
        const data = {
            jobId: formData.jobId,
            dt: formData.dt,
            itemId: formData.itemId,
            userId: formData.userId,
            total: formData.total,
            departData: departData
        };
        return data;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const finalobj = postObj(formData, departData);
        // console.log(finalobj)
        dispatch(updateJobRate(finalobj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Employee Updated Successful");
                alert("Job Rate Updated Successful");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };


    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Item', name: 'itemNm', type: 'readOnly' }
    ];

    const dropdownlistfirst = [

        {
            label: 'Item',
            id: 'itemId',
            options: itemList?.data || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];
    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Job Rate Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {/* {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                } */}


                                {departData?.length > 0 &&
                                    <table>
                                        <thead>
                                            {departData?.map((dept, index) => (<th key={index}>{dept.departNm}</th>))}

                                            <th>Total</th>
                                        </thead>
                                        <tbody>
                                            {departData?.map((dept, index) => (
                                                <td key={index}>
                                                    <input
                                                        type='text'
                                                        placeholder='0'
                                                        value={dept.rate || ""}
                                                        onChange={(e) => handleInputChange2(e, index)}
                                                        style={{ width: '100px', fontSize: '17px' }}
                                                    />
                                                </td>))}

                                            <td style={{ fontSize: '17px' }}>
                                                {formData.total}
                                            </td>
                                        </tbody>
                                    </table>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default JobRateEdit;